export default __webpack_public_path__ + "static/media/airbnb-icon.2edd7d36.svg";